<template>
  <div class="home-wrapper">
    <section class="top-nav">
      <img src="./img/hudong_logo.png" alt="交互">
    </section>
    <section class="conten-t-wrapper">
      <div class="left-content-container">
        <div class="content-wrapper">
          <div class="recommend">{{ consent_count }}</div>
          <p class="recommend-des">你是第{{ consent_count }}位为港珠澳大桥点赞的人</p>
          <img
            class="like-icon"
            :src="require('./img/like-icon.png')"
            alt="likeIcon"
            @click="actionForRecommendOrDis"
          >
        </div>
        <img class="icon" src="./img/submit.png" alt="">
      </div>
      <div class="right-content-container">
        <div class="talk-content-area">
          <span class="view-word">留言精选</span>
          <ul class="approval-content-area">
            <li v-for="(item, index) in commentList" :key="index" class="content-wrapper">
              <span class="item-icon"/>
              <span class="item-text-area">{{ item.message }}</span>
            </li>
            <li class="content-wrapper load-more-wrapper">
              <span class="load-more" @click="getApprovaledComments">加载更多内容</span>
            </li>
          </ul>
          <div class="get-idea-area">
            <span class="icon"/>
            <div class="input-wrapper">
              <input v-model="message" class="input-area" type="area" placeholder="请输入您想要留言的内容">
              <span class="send-btn" @click="releaseComments"/>
            </div>
          </div>
        </div>
      </div>
    </section>
    <guide-button class="btn-lt" @click="$router.back()">返回</guide-button>
    <nav-bar/>
  </div>
</template>

<script>
import { InteractiveApiFun } from '@/service/webapi/apiFun'
export default {
  name: 'Interact',
  inject: ['app'],
  data () {
    return {
      consent_count: 0,
      message: '',
      currentIndex: 0,
      commentList: [],
    }
  },
  mounted () {
    this.getThemeInfo()
    this.getApprovaledComments()
    this.$bgAudio.play()
  },
  beforeDestroy () {
    this.$bgAudio.pause()
  },
  methods: {
    // 获取点赞数
    getThemeInfo () {
      InteractiveApiFun.getThemeInfo().then(res => {
        if (res.status) {
          this.consent_count = res.data.consent_count || 0
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 点赞
    actionForRecommendOrDis () {
      const obj = {
        type: 1,
      }
      InteractiveApiFun.actionForRecommendOrDis(obj).then(res => {
        if (res.status) {
          this.getThemeInfo()
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 发布评论
    releaseComments () {
      if (!this.message) {
        return
      }
      const obj = {
        message: this.message,
      }
      InteractiveApiFun.releaseComment(obj).then(res => {
        if (res.status) {
          alert('您的留言已提交成功，正在审核。')
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 获取已审核评论
    getApprovaledComments () {
      this.currentIndex += 1
      const obj = {
        limit: 20,
        offset: (this.currentIndex - 1) * 10,
      }
      InteractiveApiFun.getApprovaledComments(obj).then(res => {
        if (res.status === 200) {
          this.commentList = [...this.commentList, ...res.data.data]
        }
      }).catch(err => {
        console.log(err)
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.home-wrapper {
  height: 100%;
  background-repeat: no-repeat;
  background-image: url(./img/bg-jiaohu.png);
  background-size: 100%;
  padding: 0.01rem;
  .top-nav {
    margin: 0.5rem;
    text-align: center;
    & > img {
      height: 0.9rem;
    }
  }
  .conten-t-wrapper {
    text-align: center;
    height: 6.3rem;
    .left-content-container {
      position: relative;
      display: inline-block;
      width: 7rem;
      height: 100%;
      .content-wrapper {
        text-align: center;
        .recommend {
          margin-bottom: 0.2rem;
          font-size: 1.4rem;
          line-height: 2.3rem;
          text-align: center;
          color: #fff;
          background: url(./img/recommend-bg.png) no-repeat;
          background-size: 100% 100%;
          text-shadow: 1px 1px 6px #fff;
        }
        .recommend-des {
          margin-bottom: 0.2rem;
          font-size: 0.34rem;
          color: #fff;
        }
        .like-icon {
          width: 4.2rem;
          cursor: pointer;
        }
      }
      .icon {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
      }
    }
    .right-content-container {
      display: inline-block;
      height: 100%;
      margin-left: 0.48rem;
      vertical-align: top;
      .talk-content-area {
        position: relative;
        width: 7rem;
        height: 100%;
        padding: 0.6rem 0.2rem;
        box-sizing: border-box;
        background: url("./img/talk-bg.png") no-repeat;
        background-size: 100% 100%;
        .view-word {
          position: absolute;
          font-size: 0.2rem;
          top: 0.08rem;
          left: 0.2rem;
          color: #fff;
        }
        .bottom-text-des {
          position: absolute;
          bottom: 0.13rem;
          font-size: .2rem;
          color: #fff;
        }
        .approval-content-area {
          height: 4rem;
          overflow: auto;
          &::-webkit-scrollbar {
            /*滚动条整体样式*/
            width: 12px; /*高宽分别对应横竖滚动条的尺寸*/
            height: 12px;
          }
          &::-webkit-scrollbar-thumb {
            /*滚动条里面小方块*/
            border-radius: 10px;
            background: rgba(0, 0, 0, 0.2);
          }
          &::-webkit-scrollbar-track {
            /*滚动条里面轨道*/
            border-radius: 0;
            background: rgba(0, 0, 0, 0.1);
          }
          .content-wrapper {
            font-size: 0;
            margin-bottom: 0.18rem;
            text-align: left;
            &.load-more-wrapper {
              width: 4rem;
              border-radius: 30px;
              margin: 0 auto;
              font-size: 0.24rem;
              color: #2f6c98;
              text-align: center;
              background: #cdddff;
              cursor: pointer;
              .load-more {
                margin: 0 auto;
                line-height: 2;
              }
            }
            .item-icon {
              display: inline-block;
              width: 0.5rem;
              height: 0.5rem;
              border-radius: 50%;
              margin-right: 0.15rem;
              font-size: 0;
              background: url('./img/other-icon.png') no-repeat;
              background-size: contain;
            }
            .item-text-area {
              display: inline-block;
              padding: 0.1rem .3rem;
              width: 4.8rem;
              text-align: left;
              background: #cdddff;
              color: #195780;
              font-size: 0.2rem;
              line-height: 1.5;
              vertical-align: top;
            }
          }
        }
        .get-idea-area {
          position: absolute;
          bottom: 0.5rem;
          // text-align: center;
          font-size: 0;
          .icon {
            display: inline-block;
            width: 0.5rem;
            height: 0.5rem;
            border-radius: 50%;
            background: url('./img/current-icon.png') no-repeat;
            background-size: 100%;
            margin-right: 0.13rem;
            vertical-align: top;
          }
          .input-wrapper {
            display: inline-block;
            height: 0.72rem;
            width: 5.1rem;
            padding-left: 0.3rem;
            text-align: left;
            z-index: 0;
            background: #e3746f;
            input::-webkit-input-placeholder {
              /* WebKit browsers */
              color: #fff;
            }
            input:-moz-placeholder {
              /* Mozilla Firefox 4 to 18 */
              color: #fff;
            }
            input::-moz-placeholder {
              /* Mozilla Firefox 19+ */
              color: #fff;
            }
            input:-ms-input-placeholder {
              /* Internet Explorer 10+ */
              color: #fff;
            }
            .input-area {
              width: 4rem;
              height: 100%;
              padding: 0;
              border: none;
              font-size: 0.2rem;
              line-height: 0.72rem;
              color: #fff;
              vertical-align: bottom;
              background: transparent;
              &:focus {
                outline: none;
              }
            }
            .send-btn {
              float: right;
              height: 0.72rem;
              width: 0.7rem;
              margin-right: auto;
              background: url("./img/send-btn.png") no-repeat;
              background-color: #9e3627;
              background-position: 50%;
              background-size: 60%;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
</style>
